// constants/features.ts
const FEATURES = {
  recipes: false, // disattiva tutto ciò che riguarda le ricette lato frontend
};

export default FEATURES;
